'use client'

import { Box, LogoSymbol, ActionButton, Text, ThemeProvider } from '@carla/flora'
import { useAuth } from '@/app/hooks/useAuth'

interface HeaderProps {
  children: React.ReactNode
}

export default function Header({ children }: HeaderProps) {
  const { user, isAuthenticated, login, logout } = useAuth()

  return (
    <Box minHeight={'100vh'}>
      <ThemeProvider theme={'dark'}>
        <Box height={70} direction={'row'} justifyContent={'space-between'} bg={'background.primary'} space={4} padding={5}>
          <Box direction={'row'} alignItems={'center'} space={2}>
            <LogoSymbol size={25} color="primary" />
            <Text variant={'ash'}>Safety Culture Configuration</Text>
          </Box>
          <Box direction={'row'} alignItems={'center'}>
            {!isAuthenticated && (
              <Box className="w-[100px]" direction={'row'} space={2} alignItems={'center'}>
                <ActionButton intent="link" onClick={login}>
                  Sign in
                </ActionButton>
              </Box>
            )}
            {isAuthenticated && (
              <Box direction={'row'} space={5} alignItems={'center'}>
                <Box as={'img'} src={user?.picture} extend={{ borderRadius: '50%' }} width={50} />
                <Box>
                  <Text>{user?.name}</Text>
                  <Text variant={'birch'}>{user?.email}</Text>
                </Box>
                <Box className="w-[100px]" direction={'row'} space={2} alignItems={'center'}>
                  <ActionButton intent="link" onClick={logout}>
                    Sign out
                  </ActionButton>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </ThemeProvider>
      <ThemeProvider theme={'light'}>
        {!isAuthenticated && (
          // create dotted background pattern using tailwind
          <Box padding={5} extend={{ height: 'calc(100vh - 110px)' }} alignItems="center" justifyContent="center">
            <Text color={'black'} variant={'ash'}>
              Please log in to access the application.
            </Text>
          </Box>
        )}
        {isAuthenticated && children}
      </ThemeProvider>
    </Box>
  )
}
